// @flow

import 'styles/css/sweetalertModalCustom.css';
import * as Yup from 'yup';
import React, { Component } from 'react';
import HomieContext from 'HomieContext';
import swal from '@sweetalert/with-react';
import { media } from 'styles/Mixins';
import styled from 'styled-components';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { ScreenOverlay, ModalBody, CloseButton } from 'styles/Modals';
import Cookie from 'utils/Cookie';
import FavoriteAction from 'actions/FavoriteActions';
import AuthenticationAction from 'actions/AuthenticationAction';
import googleTagManager from 'utils/GoogleTagManager';
import ApiServiceH360 from 'modules/h360/api/ApiService';
import HomeApplicationActions from 'actions/HomeApplicationActions';
import { EyePassword } from '../EyePassword';
import { goToNewOnBoarding } from 'utils/utils';

const Container = styled.div`
  margin: 0 auto;
  text-align: ${({ align }) => (align ? 'center' : 'left')};
  ${({ align }) => align && `width: 300px;`}
  padding-top: 60px;
  ${media.md`
    padding-top: 0;
    margin-left:auto;
    margin-right:auto;
  `}
`;

const ContainerForm = styled.div``;

const Label = styled.label.attrs({
  style: ({ fsize }) => ({
    fontSize: fsize
  })
})`
  height: 24px;
  color: #4a4a4a;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: ${({ modal }) => (modal ? 10 : 20)}px;
`;

const LinkStyle = styled.a`
  height: 19px;
  color: #278c7e;
  font-size: 16px;
  line-height: 19px;
  cursor: pointer;
  ${props => props.align && 'float: right'};
  &:hover {
    color: #278c7e;
  }
`;

const ScreenModalBody = styled(ModalBody)`
  margin: 0 auto;
  width: 345px;
  position: fixed;
  border-radius: 2px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  top: 50%;
  left: 50%;
  margin-top: -99px;
  margin-left: -173px;
  color: #4a4a4a;
  text-align: center;
`;

const ScreenCloseModal = styled(CloseButton)`
  display: block;
  color: #278c7e;
  font-weight: 700;
  font-size: 30px;
  padding-right: 2px;
`;

const WrapperActionModal = styled.div`
  height: 20px;
  line-height: 40px;
  ${media.md`
    height: 40px;
  `}
`;

const StyledInput = styled(Field)`
  display: block;
  width: 100%;
  height: 35px;
  padding: 10px 15px;
  border: 1px solid #ececec;
  border-radius: 2px;
  background-color: white;
  line-height: 35px;
  font-size: 14px;
`;

const StyledInputPassword = styled(Field)`
  display: absolute;
  width: 100%;
  height: 35px;
  padding: 10px 15px;
  border: 1px solid #ececec;
  border-radius: 2px;
  background-color: white;
  line-height: 35px;
  font-size: 14px;
`;

const StyledValidatedInput = styled.div`
  position: relative;
  margin-bottom: 20px;
`;

const StyledErrorMessage = styled(ErrorMessage)`
  color: red;
  position: absolute;
  top: 35px;
  font-size: 14px;
`;

const StyledSubmitButton = styled.button.attrs({
  style: ({ modal }) => ({
    marginTop: modal ? 10 : 30,
    marginBottom: modal ? 20 : 30
  })
})`
  width: 100%;
  height: 35px;
  line-height: 19px;
  color: #ffffff;
  border: none;
  border-radius: 2px;
  font-size: 16px;
  font-weight: bold;
  background-color: #278c7e;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  transition: background-color 0.2s linear;
  &:hover {
    background-color: #278c7e;
  }
`;

type PropsType = {
  align: boolean,
  maxfontsize: number,
  handleRedirect: () => void
};

type State = {
  modal: boolean,
  send: boolean
};

type FormFormik = {
  email: string,
  password: string
};

class View extends Component<PropsType, State> {
  constructor(props: PropsType) {
    super(props);
    this.state = {
      modal: false,
      send: false,
      showPassword: false
    };
    this.actionModal = this.actionModal.bind(this);
  }

  defaultValues = (): FormFormik => {
    return {
      email: '',
      password: ''
    };
  };

  validationSchema = () => {
    return Yup.object().shape({
      email: Yup.string()
        .email('Ingresa un correo electrónico valido')
        .required('Campo requerido'),
      password: Yup.string().required('Campo requerido')
    });
  };

  passwordRecoveryValidationSchema = () => {
    return Yup.object().shape({
      email: Yup.string()
        .email('Ingresa un correo electrónico valido')
        .required('Campo requerido')
    });
  };

  submitData = (values: FormFormik, { resetForm }: any): void => {
    this.context.showLoadingProcessView('Preparando datos');
    const data = {
      user: {
        remember_me: 1,
        email: values.email,
        password: values.password
      },
      from_axios: true
    };
    AuthenticationAction.loginUser(
      data,
      () => {
        this.handleLoginRedirect();
      },
      (errors: any) => {
        this.context.hideLoadingProcessView();
        swal({
          type: 'error',
          title: '¡Ha ocurrido un error!',
          text:
            errors.responseJSON && errors.responseJSON.message
              ? errors.responseJSON.message
              : 'Intente de nuevo más tarde',
          timer: 5000
        });
      }
    );
  };

  submitPasswordRecoveryData = (values: FormFormik): void => {
    this.context.showLoadingProcessView('Preparando datos');
    const data = {
      user: { email: values.email }
    };

    AuthenticationAction.sendRestorePasswordEmail(
      data,
      () => {
        this.setState({ modal: false });
        swal({
          className: 'recoverModal',
          content: (
            <div>
              <h3>Recupera tu contraseña</h3>
              <p>
                Te enviamos un correo a
                <span style={{ color: '#278C7E', padding: '0 8px' }}>
                  {values.email}
                </span>
                para que cambies tu contraseña
              </p>
            </div>
          ),
          timer: 5000
        }).then(() => {
          this.context.hideLoadingProcessView();
        });
      },
      (errors: any) => {
        swal({
          type: 'error',
          title: '¡Ha ocurrido un error!',
          text:
            errors.responseJSON && errors.responseJSON.message
              ? errors.responseJSON.message
              : 'Intente de nuevo más tarde',
          timer: 5000
        }).then(() => {
          this.context.hideLoadingProcessView();
        });
      }
    );
  };

  actionModal = (): void => {
    this.setState({ modal: !this.state.modal });
  };

  handleLoginRedirect = async () => {
    const { currentUser } = this.context;
    const { tenantType } = currentUser;
    /*  const queries = queryString.parse(location?.search);

    if (queries?.home_id) {
      HomeApplicationActions.createHomeApplication(
        {
          home_application: {
            home_id: queries?.home_id,
            campaign: queries?.utm_campaign ?? null,
            utm_medium: queries?.utm_medium ?? null
          }
        },
        () => {},
        errorMessage
      );
    } */

    if (tenantType === 're_manager_company') {
      const response = await HomeApplicationActions.getHomeApplications(
        currentUser.id
      );
      const { home_applications = [] } = response;
      const pendingApplication = home_applications.find(
        homeApplication => homeApplication.status === 'pending'
      );

      if (pendingApplication) {
        const { application_form } = pendingApplication;
        if (application_form) {
          const { re_management_company_slug } = application_form;
          document.location.href = `/h/gestores-inmobiliarios/${re_management_company_slug}/usuarios/autenticacion`;
          return;
        }
      }
    }

    if (currentUser.isAdvisor) {
      return ApiServiceH360.getUser(currentUser.id).then(response => {
        const { advisor } = response.data.user;
        const url = advisor.agencyBusinessPartner
          ? `/h/agencia/inmuebles/${advisor.agencyBusinessPartner.slug}`
          : '/h/agencia/h360/publicar/inmueble/nuevo';

        goToNewOnBoarding(
          currentUser.isAdvisor,
          currentUser.isOwner,
          history,
          '/propietario/registra-tu-inmueble/ubicacion',
          url,
          false,
          true
        );
      });
    }
    return this.saveFavorites();
  };

  saveFavorites = (): void => {
    if (Cookie.get('campaign')) {
      googleTagManager.methods.triggerFromCampaign(window.location.href);
    } else {
      googleTagManager.methods.triggerFromLogin(window.location.href);
    }
    const cookieHomes = JSON.parse(Cookie.get('favorite_depa'));
    this.context.hideLoadingProcessView();
    if (cookieHomes && cookieHomes.length > 0) {
      FavoriteAction.saveFavoritesAfterLogin(
        this.context.currentUser.id,
        cookieHomes,
        () => {
          Cookie.set('favorite_depa', '[]', 0, 1);
          this.props.handleRedirect();
        }
      );
    } else {
      this.props.handleRedirect();
    }
  };

  renderLoginForm = (formik: any) => {
    const { errors, touched } = formik;
    return (
      <Form autoComplete="off">
        <StyledValidatedInput>
          <StyledInput
            type="text"
            name="email"
            placeholder="Correo electrónico"
            className={errors.email && touched.email ? 'has-error' : ''}
          />
          <StyledErrorMessage name="email" component="div" />
        </StyledValidatedInput>
        <StyledValidatedInput>
          <StyledInputPassword
            type={this.state.showPassword ? 'text' : 'password'}
            name="password"
            placeholder="Contraseña"
            className={errors.password && touched.password ? 'has-error' : ''}
          />
          <EyePassword
            showPassword={this.state.showPassword}
            colorIcon={'#858585'}
            style={{
              position: 'absolute',
              right: '10',
              top: '10'
            }}
            onClick={() =>
              this.setState({ showPassword: !this.state.showPassword })
            }
          />
          <StyledErrorMessage name="password" component="div" />
        </StyledValidatedInput>
        <LinkStyle align onClick={this.actionModal}>
          ¿Olvidaste tu contraseña?
        </LinkStyle>
        <StyledSubmitButton type="submit">Continuar</StyledSubmitButton>
      </Form>
    );
  };

  renderPasswordRecoveryForm = (formik: any) => {
    const { errors, touched } = formik;
    return (
      <Form autoComplete="off">
        <StyledValidatedInput>
          <StyledInput
            type="text"
            name="email"
            placeholder="Correo electrónico"
            className={errors.email && touched.email ? 'has-error' : ''}
          />
          <StyledErrorMessage name="email" component="div" />
        </StyledValidatedInput>
        <StyledSubmitButton modal type="submit">
          Continuar
        </StyledSubmitButton>
      </Form>
    );
  };

  render() {
    const { align } = this.props;
    const { modal } = this.state;

    return (
      <Container align={align}>
        <ContainerForm>
          <ScreenOverlay show={modal}>
            <ScreenModalBody>
              <WrapperActionModal>
                <ScreenCloseModal onClick={this.actionModal}>
                  &times;
                </ScreenCloseModal>
              </WrapperActionModal>
              <Label modal fsize={this.props.maxfontsize - 2}>
                Recupera tu contraseña
              </Label>
              <Formik
                initialValues={this.defaultValues()}
                validationSchema={this.passwordRecoveryValidationSchema()}
                onSubmit={this.submitPasswordRecoveryData}
                render={this.renderPasswordRecoveryForm}
              />
            </ScreenModalBody>
          </ScreenOverlay>
          <Label fsize={this.props.maxfontsize}> Inicia sesión </Label>
          <Formik
            initialValues={this.defaultValues()}
            validationSchema={this.validationSchema()}
            onSubmit={this.submitData}
            render={this.renderLoginForm}
          />
        </ContainerForm>
      </Container>
    );
  }
}
View.contextType = HomieContext;
export default View;
